import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideIcons } from './shared/icons/icons.provider';
import { TokenInterceptor } from './shared/interceptors/auth.interceptor';
import { ApiErrorsInterceptor } from './shared/interceptors/api-errors.interceptor';
import { environment } from '../environments/environment';
import { importProvidersFrom } from '@angular/core';
import {
  RecaptchaV3Module,
  RECAPTCHA_V3_SITE_KEY,
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
} from 'ng-recaptcha-2';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ApiErrorsInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true,
  },
];
export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideIcons(),
    provideNativeDateAdapter(),
    importProvidersFrom(RecaptchaV3Module),
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.siteKey },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.siteKey,
      } as RecaptchaSettings,
    },
    httpInterceptorProviders,
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
  ],
};
